"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER = exports.EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER = exports.INTEGRATION_JOB_PARAMETER = exports.STREAM_JOB_PARAMETER = exports.HTTP_REQUEST_JOB_PARAMETER = exports.NOTIFICATION_JOB_PARAMETER = exports.TRANSFORMATION_JOB_PARAMETER = exports.STEP_STATUS = void 0;
var STEP_STATUS;
(function (STEP_STATUS) {
    STEP_STATUS["PENDING"] = "PENDING";
    STEP_STATUS["ONGOING"] = "ONGOING";
    STEP_STATUS["DONE"] = "DONE";
    STEP_STATUS["FAILURE"] = "FAILURE";
    STEP_STATUS["OUTDATED"] = "OUTDATED";
    STEP_STATUS["CANCELLED"] = "CANCELLED";
    STEP_STATUS["WARNING"] = "WARNING";
    STEP_STATUS["SKIPPED"] = "SKIPPED";
    STEP_STATUS["TO_SKIP"] = "TO_SKIP";
    STEP_STATUS["ACTIVITIES_DONE"] = "ACTIVITIES_DONE";
})(STEP_STATUS || (exports.STEP_STATUS = STEP_STATUS = {}));
var TRANSFORMATION_JOB_PARAMETER;
(function (TRANSFORMATION_JOB_PARAMETER) {
    TRANSFORMATION_JOB_PARAMETER["QUERY"] = "query";
    TRANSFORMATION_JOB_PARAMETER["TERMINATION_TIME"] = "termination_time";
})(TRANSFORMATION_JOB_PARAMETER || (exports.TRANSFORMATION_JOB_PARAMETER = TRANSFORMATION_JOB_PARAMETER = {}));
var NOTIFICATION_JOB_PARAMETER;
(function (NOTIFICATION_JOB_PARAMETER) {
    NOTIFICATION_JOB_PARAMETER["SUBJECT"] = "subject";
    NOTIFICATION_JOB_PARAMETER["BODY"] = "body";
    NOTIFICATION_JOB_PARAMETER["RECIPIENTS"] = "recipients";
    NOTIFICATION_JOB_PARAMETER["QUERIES"] = "queries";
})(NOTIFICATION_JOB_PARAMETER || (exports.NOTIFICATION_JOB_PARAMETER = NOTIFICATION_JOB_PARAMETER = {}));
var HTTP_REQUEST_JOB_PARAMETER;
(function (HTTP_REQUEST_JOB_PARAMETER) {
    HTTP_REQUEST_JOB_PARAMETER["BODY"] = "body";
    HTTP_REQUEST_JOB_PARAMETER["URL"] = "url";
    HTTP_REQUEST_JOB_PARAMETER["query"] = "query";
})(HTTP_REQUEST_JOB_PARAMETER || (exports.HTTP_REQUEST_JOB_PARAMETER = HTTP_REQUEST_JOB_PARAMETER = {}));
var STREAM_JOB_PARAMETER;
(function (STREAM_JOB_PARAMETER) {
    STREAM_JOB_PARAMETER["INPUT"] = "input";
})(STREAM_JOB_PARAMETER || (exports.STREAM_JOB_PARAMETER = STREAM_JOB_PARAMETER = {}));
var INTEGRATION_JOB_PARAMETER;
(function (INTEGRATION_JOB_PARAMETER) {
    INTEGRATION_JOB_PARAMETER["INPUT"] = "input";
})(INTEGRATION_JOB_PARAMETER || (exports.INTEGRATION_JOB_PARAMETER = INTEGRATION_JOB_PARAMETER = {}));
var EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER;
(function (EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER) {
    EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER["STEP_ID"] = "step_id";
})(EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER || (exports.EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER = EXPORT_ACTIVITY_REPORT_PDF_JOB_PARAMETER = {}));
var UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER;
(function (UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER) {
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["PROJECT_ID"] = "project_id";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["DATASET_ID"] = "dataset_id";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["URL"] = "url";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["COPY_ORIGINAL"] = "copy_original";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["EXTERNAL_ID"] = "external_id";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["FILENAME"] = "filename";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["DEFAULT_CLASS_ID"] = "default_class_id";
    UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER["ENABLE_AUTOMATED_LABELLING"] = "enable_automated_labelling";
})(UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER || (exports.UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER = UPLOAD_IMAGE_TO_HASTY_JOB_PARAMETER = {}));
